// extracted by mini-css-extract-plugin
export default {"widgetBox":"mHCF64hPySvzi1LoWOPh","titleBox":"bEPPXrAH4EvUcCOGQRAY","titleInfo":"WsrKij8A_fULuwwJxA_Q"};